import { createAsyncThunk } from '@reduxjs/toolkit';

import { handleListFetch } from '../apiHelpers';

import {
    APIUserGroupUserMembershipDelete,
    APIUserGroupUserMembershipGetList,
    APIUserGroupUserMembershipPost } from './UserGroupUserMembership.api';

export const fetchUserGroupUserMembershipList = createAsyncThunk('users/fetchUserGroupUserMembershipList', async (params: {tenantId: string, userId: string, signal?: AbortSignal}) => {
    const response = await APIUserGroupUserMembershipGetList(params);
    return _formatUserGroupUserMembershipRows(response.data);
});

export const deleteUserGroupsUserMembershipList = createAsyncThunk('users/deleteUserGroupUserMembership', async (item: {tenantId: string, userId: string, userGroupId: string})=> {
    const response = await APIUserGroupUserMembershipDelete(item);
    const rows = await APIUserGroupUserMembershipGetList({ tenantId: item.tenantId, userId: item.userId });
    const formattedData = _formatUserGroupUserMembershipRows(rows.data);

    return {
        response,
        formattedData
    };
});

export const postUserGroupUserMembership = createAsyncThunk('users/postUserGroupUserMembership', async (item: {
    tenantId: string,
    userGroupId: string,
    userId: string
}) => {
    const response = await APIUserGroupUserMembershipPost(item);
    const rows = await handleListFetch(APIUserGroupUserMembershipGetList({ tenantId: item.tenantId, userId: item.userId }));
    return {
        response,
        rows: _formatUserGroupUserMembershipRows(rows)
    };
});

const _formatUserGroupUserMembershipRows = (rows: {
    userGroupId: string;
    userId: string;
    userGroup: {
        id: string;
        name:string;
        description:string;
        tenantId:string;
    }
}[])  => {
    return rows.map(item => {
        return {
            ...item,
            id: item.userGroupId,
            name: item.userGroup.name,
            description: item.userGroup.description,
        };
    });
};
